import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {Mutation} from 'react-apollo';
import {Col, Container, Row} from 'react-bootstrap';
import {withTranslation} from 'react-i18next';
import {PulseLoader} from 'react-spinners';
import Error from '../../../common/components/Error/Error';
import MandatoryInput from '../../../common/components/layout/MandatoryInput';
import PopIn from '../../../common/components/PopIn';
import {CancelButton, FooterRow, GradientCol, TitleButton} from '../../../common/components/StyledComp';
import {GRAPHQL_MUTATION_ADD_TAG} from '../../../common/queries/tag';

const AddTag = props => {
  const {t} = props;

  const [modalVisible, setModalVisible] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [name, setName] = useState('');

  const onTagAdded = addTag => {
    addTag().then(({data}) => {
      if (data.addTag) {
        setModalVisible(false);
        setName('');
      }
    });
  };

  return (
    <Mutation
      mutation={GRAPHQL_MUTATION_ADD_TAG}
      variables={{tagInput: {name}}}
      onCompleted={() => {
        setSubmitted(false);
      }}
      refetchQueries={['tags']}
    >
      {(addTag, {error, loading}) => {
        return (
          <div>
            <TitleButton onClick={() => setModalVisible(true)} className="title-btn">
              {t('addTag')}
            </TitleButton>

            <PopIn visible={modalVisible} setModalVisible={setModalVisible} title={t('addTag')}>
              <Container>
                <form
                  onSubmit={e => {
                    e.preventDefault();
                    if (name !== '') {
                      onTagAdded(addTag);
                    }
                  }}
                >
                  <Row>
                    <Col xs={9} className="extended-col">
                      <PulseLoader loading={loading}/>
                      <MandatoryInput
                        type="text"
                        title={t('name')}
                        placeholder={t('name')}
                        name="name"
                        onChange={(name, text) => {
                          setName(text);
                          setSubmitted(false);
                        }}
                        show={name === '' && submitted}
                      />
                    </Col>
                  </Row>
                  <FooterRow>
                    <GradientCol sm={{span: 6, offset: 3}}>
                      <Error error={error}/>
                      <div className="popin-buttons">
                        <TitleButton
                          type="submit"
                          disabled={loading}
                          onClick={() => {
                            setSubmitted(true);
                          }}>
                          {t('addTag')}
                        </TitleButton>
                        <CancelButton
                          onClick={() => {
                            setModalVisible(false);
                            setName('');
                            setSubmitted(false);
                          }}
                          style={{marginTop: 0, width: 'auto'}}>
                          {t('cancel')}
                        </CancelButton>
                      </div>
                    </GradientCol>
                  </FooterRow>
                </form>
              </Container>
            </PopIn>
          </div>
        );
      }}
    </Mutation>
  );
};

AddTag.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('tag')(AddTag);
